// extracted by mini-css-extract-plugin
module.exports = {"loading-screen":"Loading_loading-screen__339n_","loading-icon":"Loading_loading-icon__2bA8f"};